import ProfileCard from "Components/molecule/overview-header/profile-overview-header"
import Breadcrumb from "Components/organisms/breadcrumb"
import { Department, JobTitle } from "models/org-chart-node"
import Employee from "models/employee"
import { Container } from "reactstrap"
import Tabs from "Components/molecule/tabs"
import ResetPasswordForm from "Components/organisms/forms/reset-password"
import FormProps from "data/forms"
import ResetPasswordFields from "Components/organisms/forms/reset-password/types"
import ActionButton from "Components/atoms/buttons/action-button"
import { HelpIcon } from "Components/atoms/icons"


interface ProfileTemplateProps extends FormProps<ResetPasswordFields> {
    jobTitle: JobTitle | null
    department: Department | null
    employee: Employee | null
    activeTab: string,
    setActiveTab: React.Dispatch<React.SetStateAction<string>>,
    isEditing: boolean,
    willingToRelocate: boolean,
    onEdit: () => void,
    onSave: () => void,
    onCancel: () => void,
    onChangeWillingToRelocate: (value: boolean) => void,
    handleOpenHelpDocument?: () => any,
}


const ProfileTemplate = ({
    jobTitle,
    department,
    employee,
    values,
    errors,
    touched,
    isValid,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    setActiveTab,
    activeTab,
    isEditing,
    willingToRelocate,
    onEdit,
    onSave,
    onCancel,
    onChangeWillingToRelocate,
    handleOpenHelpDocument
}: ProfileTemplateProps) => {

    return <div className="page-content">
        <Container fluid style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Breadcrumb
                title="User Profile"
                breadcrumbItem="Profile"
                actions={<>
                    {
                        !isEditing ? (
                            <ActionButton onClick={onEdit}>Edit</ActionButton>
                        ) : (
                            <>
                                <ActionButton onClick={onSave}>Save</ActionButton>
                                <ActionButton onClick={onCancel}>Cancel</ActionButton>
                            </>
                        )
                    }
                    {handleOpenHelpDocument && (
                        <ActionButton onClick={() => handleOpenHelpDocument()}>
                            Help <HelpIcon />
                        </ActionButton>
                    )}
                </>}
            />

            <div className="section-container">
                <ProfileCard
                    jobTitle={jobTitle}
                    department={department}
                    employee={employee}
                    isEditing={isEditing}
                    willingToRelocate={willingToRelocate}
                    onEdit={onEdit}
                    onSave={onSave}
                    onCancel={onCancel}
                    onChangeWillingToRelocate={onChangeWillingToRelocate}
                />
            </div>


            <div className="section-container">
                <Tabs
                    setActiveTab={setActiveTab}
                    activeTab={activeTab}
                    headers={["Security"]}
                    tabs={{
                        "Security": <ResetPasswordForm
                            values={values}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            handleSubmit={handleSubmit}
                            isValid={isValid}
                            isSubmitting={isSubmitting}
                            edit={false} />
                    }}               />
            </div>


        </Container>
    </div>
}

export default ProfileTemplate